(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["share-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.share-button');
    if (!btn) return;
    var url = btn.getAttribute('data-url');
    var title = btn.getAttribute('data-title');
    var label = btn.querySelector('.share-button__label');
    var originalText = label.textContent;
    if (navigator.share) {
      try {
        await navigator.share({ title: title, url: url });
      } catch (err) {
        /* user cancelled share - no-op */
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      label.textContent = btn.getAttribute('data-copied-text');
      setTimeout(function () {
        label.textContent = originalText;
      }, 2000);
    } catch (err) {
      window.prompt('Copy this link:', url);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wishlist-button"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'chandravastra_wishlist';

    function getWishlist() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (err) {
        return [];
      }
    }

    function setWishlist(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (err) {}
    }

    function refreshButtonState(btn) {
      var handle = btn.getAttribute('data-product-handle');
      var list = getWishlist();
      var isSaved = list.indexOf(handle) !== -1;
      btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    }

    document.querySelectorAll('.wishlist-button').forEach(refreshButtonState);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wishlist-button');
      if (!btn) return;
      var handle = btn.getAttribute('data-product-handle');
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if (idx === -1) {
        list.push(handle);
      } else {
        list.splice(idx, 1);
      }
      setWishlist(list);
      refreshButtonState(btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
